import {combineReducers} from 'redux';
import followingStrategiesReducer from './followingStrategies';
import followingPicksReducer from './followingPicks';
import favoritePicksReducer from './favoritePicks';
import userReducer from './user';
import uiReducer from './ui';

export default combineReducers({
  followingStrategies: followingStrategiesReducer,
  followingPicks: followingPicksReducer,
  favoritePicks: favoritePicksReducer,
  user: userReducer,
  ui: uiReducer,
});
